import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { findDictionaryItemByValue, tableElementColumnViewType } from "shared/rsDictionary";
import Select from "components/Controls/Select";
import SelectItemRenderer from "rs-components/Input/components/SelectInput/components/SelectItemRenderer";
import { updateTableElementView } from "store/rs-workspace/actions/results.actions";
import ChevronDown from "icons/rs_chevron_down.svg";
import * as styles from "./styles.module.scss";
const ViewSelect = ({ editMode, column, selectRef, resultSetId, elementId, editColumn }) => {
    const dispatch = useDispatch();
    const handleColumnViewUpdate = useCallback((value) => {
        if (editMode) {
            editColumn({
                ...column,
                columnId: column.id,
                view: value.value,
                type: column.parameter.type,
            });
        }
        else {
            if (column.id !== undefined) {
                dispatch(updateTableElementView({
                    resultSetId,
                    elementId,
                    items: [{ id: column.id, viewType: value.value }],
                }));
            }
        }
    }, [column, dispatch, editColumn, editMode, elementId, resultSetId]);
    return (React.createElement("div", { className: styles.viewSelectWrapper },
        React.createElement(Select, { selectRef: selectRef, key: column.id, selectButtonProps: { customChevron: React.createElement(ChevronDown, null) }, popoverProps: { rootBoundary: "viewport", transitionDuration: 0 }, itemRenderer: SelectItemRenderer, items: tableElementColumnViewType.map((el) => ({ ...el, className: styles["viewSelect-item"] })), value: findDictionaryItemByValue(tableElementColumnViewType, column.view)?.label, classes: {
                root: styles.viewSelect,
                selectButton: styles["viewSelect-button"],
                popoverWrapper: styles["viewSelect-popoverWrapper"],
            }, onChange: handleColumnViewUpdate })));
};
export default ViewSelect;
